var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 6C4.81043 6 4.63809 5.92944 4.50022 5.78831L0.191774 1.2018C-0.0667329 0.919558 -0.0667372 0.478551 0.209003 0.196304C0.484744 -0.0683022 0.9156 -0.0683011 1.19134 0.213946L5 4.27124L8.80868 0.213946C9.06719 -0.0683011 9.51526 -0.0683022 9.791 0.196304C10.0667 0.46091 10.0667 0.919558 9.80821 1.2018L5.49978 5.78831C5.36191 5.92944 5.18957 6 5 6Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownarrow);
export default __webpack_public_path__ + "static/media/downarrow.359c9ebe0701aa2776c95853f329b7c5.svg";
export { ForwardRef as ReactComponent };